import "./notFound.css";

import React from "react";

const NotFound = () => {
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <h3>Oops! Page not found</h3>
          <h1>
            <span>4</span>
            <span>0</span>
            <span>4</span>
          </h1>
        </div>
        <h2>페이지를 찾을수 없습니다.</h2>
      </div>
    </div>
  );
};

export default NotFound;
